import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Determinate / indeterminate progress bar. Pure Angular + Tailwind. Ported
 * from the de-materialized mat-compat progress bar as part of the brandbot-kit
 * migration; replaces `<mat-progress-bar>`.
 */
@Component({
  selector: 'primecontrol-progress-bar',
  template: `
    <div class="h-1 w-full rounded-full bg-neutral-200 dark:bg-neutral-700 overflow-hidden">
      @if (mode === 'indeterminate') {
        <div
          class="h-full rounded-full bg-[color:var(--main-button-bg)] primecontrol-progress-indeterminate"
        ></div>
      } @else {
        <div
          class="h-full rounded-full bg-[color:var(--main-button-bg)] transition-[width]"
          [style.width.%]="clampedValue"
        ></div>
      }
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }

      .primecontrol-progress-indeterminate {
        width: 30%;
        animation: primecontrol-progress-slide 1.2s ease-in-out infinite;
      }

      @keyframes primecontrol-progress-slide {
        0% {
          transform: translateX(-100%);
        }
        100% {
          transform: translateX(333.33%);
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBar {
  @Input() mode: 'determinate' | 'indeterminate' = 'determinate';
  @Input() value: number = 0;
  @Input() color: string = '';

  public get clampedValue(): number {
    return Math.max(0, Math.min(100, this.value ?? 0));
  }
}
